import {
  mdiCartOutline,
  mdiWeb,
  mdiInformationOutline,
  mdiChartLine,
  mdiHeadset,
  mdiFlaskOutline,
  mdiShapeOutline,
  mdiClipboardCheckOutline,
  mdiFeatureSearchOutline,
  mdiCalendarTextOutline,
  mdiTagMultipleOutline,
  mdiRobotOutline,
  mdiCube,
  mdiCubeOutline,
  mdiAccountMultiple,
  mdiBriefcaseOutline,
} from '@mdi/js';
import {
  ROLE_DIGITAL_HEALTHCARE,
  ROLE_PATENT_SPECIALIST,
  ROLE_LOGISTIC_MANGER,
  ROLE_LOGISTIC_MANGER_READ,
  ROLE_RECOMMENDED_PRODUCTS,
  ROLE_STAFF,
  ROLE_WELLNESS_STIMULATION,
  ROLE_VAPING,
  ROLE_ADMIN,
  ROLE_PROMPTS_MANAGER,
} from 'App/constants/Roles';

export const CAT_PRODUCTS = 'products';
export const CAT_PRODUCT_MARKET_COUNTRIES = 'product_market_countries';
export const CAT_SIMILAR_PRODUCTS = 'similar-products';
export const CAT_COMPANIES = 'companies';
export const CAT_BRANDS = 'brands';
export const CAT_PATENT_RESEARCH = 'patent_research';
export const CAT_TRADEMARKS = 'trademarks';
export const CAT_CONTACTS = 'contacts';
export const CAT_COMPONENTS = 'components';
export const CAT_PATENTS = 'patents';
export const CAT_NEWS = 'news';
export const CAT_COMPANY_NEWS = 'company_news';
export const CAT_AI_NEWS = 'ai_news';
export const CAT_REPORTSARCHIVE = 'reportsarchive';
export const CAT_STANDING_REPORTS = 'standing_reports';
export const CAT_STANDING_REPORTS_SECTIONS = 'standing_report_sections';
export const CAT_FILES = 'files';
export const CAT_PRODUCT_ORDERS = 'orders';
export const CAT_TRACKING_INFORMATION = 'tracking_informations';
export const CAT_COURIER_DELIVERY_SERVICES = 'courier_delivery_services';
export const CAT_WEBSITE_DEALS = 'website_deals';
export const CAT_INFO_REQUESTS = 'info_requests';
export const CAT_ANALYZE_REQUESTS = 'analyze_requests';
export const CAT_WEBSITE_SERVICES = 'website_services';
export const CAT_WEBSITES = 'websites';
export const CAT_STATUSES = 'statuses';
export const CAT_PROJECTS = 'projects';
export const CAT_AGENTS = 'agents';
export const CAT_RECOMMENDED_PRODUCTS = 'recommended_products';
export const CAT_ORDER_AGENTS = 'order_agents';
export const CAT_CUSTOMERS = 'customers';
export const CAT_BILLING_INFORMATION = 'billing_informations';
export const CAT_CONSUMABLE_VARIATIONS = 'consumable_variations';
export const CAT_VARIATIONS = 'product-variations';
export const CAT_TYPES = 'types';
export const CAT_SAMPLES = 'samples';
export const CAT_SAMPLE_CONDITIONS = 'sample_conditions';
export const CAT_FEATURES = 'features';
export const CAT_FEATURE_OPTIONS = 'feature_options';
export const CAT_ADDITIONAL_FIELD_NAMES = 'additional_field_names';
export const CAT_PATENT_LEGAL_EVENTS = 'patent_legal_events';

export const CAT_BRAND_STAFF_STATISTICS = 'brand_staff_statistics';
export const CAT_COMPANY_STAFF_STATISTICS = 'company_staff_statistics';
export const CAT_CONTACT_STAFF_STATISTICS = 'contact_staff_statistics';
export const CAT_PATENT_STAFF_STATISTICS = 'patent_staff_statistics';
export const CAT_PRODUCT_STAFF_STATISTICS = 'product_staff_statistics';
export const CAT_EVENT_STAFF_STATISTICS = 'event_staff_statistics';
export const CAT_NEWS_STAFF_STATISTICS = 'news_staff_statistics';
export const CAT_RESEARCHE_STAFF_STATISTICS = 'research_staff_statistics';
export const CAT_COMPONENTS_STAFF_STATISTICS = 'component_staff_statistics';
export const CAT_PATENT_RESEARCH_STAFF_STATISTICS = 'patent_research_staff_statistics';
export const CAT_TRADEMARKS_STAFF_STATISTICS = 'trademark_staff_statistics';

export const CAT_BRAND_STAFF_ITEM_STATISTICS = 'brand_staff_item_statistics';
export const CAT_COMPANY_STAFF_ITEM_STATISTICS = 'company_staff_item_statistics';
export const CAT_CONTACT_STAFF_ITEM_STATISTICS = 'contact_staff_item_statistics';
export const CAT_PATENT_STAFF_ITEM_STATISTICS = 'patent_staff_item_statistics';
export const CAT_PRODUCT_STAFF_ITEM_STATISTICS = 'product_staff_item_statistics';
export const CAT_EVENT_STAFF_ITEM_STATISTICS = 'event_staff_item_statistics';
export const CAT_NEWS_STAFF_ITEM_STATISTICS = 'news_staff_item_statistics';
export const CAT_RESEARCHE_STAFF_ITEM_STATISTICS = 'research_staff_item_statistics';
export const CAT_COMPONENTS_STAFF_ITEM_STATISTICS = 'component_staff_item_statistics';
export const CAT_TRADEMARKS_STAFF_ITEM_STATISTICS = 'trademark_staff_item_statistics';
export const CAT_PATENT_RESEARCH_STAFF_ITEM_STATISTICS = 'patent_research_staff_item_statistics';
export const CAT_CPC_CLASSIFICATION = 'patents_cpc_classification';
export const CAT_IPC_CLASSIFICATION = 'patents_ipc_classification';

export const CAT_COMPONENT_PACKAGES = 'component_packages';
export const CAT_COMPONENT_CATEGORIES = 'component_categories';
export const CAT_USERS = 'users';
export const CAT_RESEARCHES = 'researches';
export const CAT_USERGROUPS = 'usergroups';
export const CAT_PROOF_REQUESTS = 'proof_requests';
export const CAT_NICE_CLASSES = 'nice_classes';
export const CAT_PATENT_CITATIONS = 'patent_citations';
export const CAT_PATENT_NOTES = 'patent_notes';
export const CAT_USER_FILTERS = 'user_filters';
export const CAT_PRODUCT_MARKETS = 'product_markets';
export const CAT_EVENTS = 'events';
export const CAT_ATTENDING_REQUESTS = 'attending_requests';
export const CAT_EVENT_TYPES = 'event_types';
export const CAT_EVENT_THEMES = 'event_themes';
export const CAT_ACTIVITY_SPHERES = 'activity_spheres';
export const CAT_PRICE_SOURCE_TYPES = 'price_source_types';
// Social media scraper
export const CAT_SOCIAL_MEDIA_SCRAPER_INSTAGRAM = 'social-media-scraper-instagram';
export const CAT_SOCIAL_MEDIA_SCRAPER_FACEBOOK = 'social-media-scraper-facebook';
export const CAT_SOCIAL_MEDIA_SCRAPER_X = 'social-media-scraper-x';
export const CAT_SOCIAL_MEDIA_SCRAPER_YOUTUBE = 'social-media-scraper-youtube';
export const CAT_SOCIAL_MEDIA_SCRAPER_LINKEDIN = 'social-media-scraper-linkedin';
export const CAT_SOCIAL_MEDIA_SCRAPER_ALL = 'social-media-scraper-all';
export const CAT_SOCIAL_MEDIA_SCRAPER_CORE_ACCOUNTS = 'social-media-scraper-core-accounts';
export const CAT_SOCIAL_MEDIA_SCRAPER_CORE_RESULTS = 'social-media-scraper-core-results';
export const CAT_SOCIAL_MEDIA_SCRAPER_CORE_SESSIONS = 'social-media-scraper-core-sessions';
export const CAT_NEWSLETTER_EMAILS = 'newsletter-emails';
export const CAT_NEWSLETTER_DOMAINS = 'newsletter-domains';
export const CAT_AI_NEWS_PROMPTS = 'ai_news_prompts';
export const CAT_INFORMATION_SOURCES = 'information_sources';
export const CAT_INFORMATION_SOURCE_SNAPSHOTS = 'information_source_snapshots';
export const CAT_GLOBAL_SEARCH = 'global_search';

export const FILE_GROUP_MODULE_PRODUCTS = 1;
export const FILE_GROUP_MODULE_COMPANY = 2;

export const SUB_PRODUCTS_VAPING_DEV = 'smoking-alternatives'; // Vaping device
export const SUB_PRODUCTS_DHW_DEV = 'digital-health-and-wellbeing-device'; // Digital Health and Wellbeing device
export const SUB_PRODUCTS_WNS_DEV = 'wellness-and-stimulation'; // Wellness and Stimulation
export const PRODUCTS_CLASSIFICATION = 'classification';
export const TEARDOWN_REPORTS = 'teardown-reports';
export const SUB_PRODUCTS_VAPING_DEV_ID = 1;
export const SUB_PRODUCTS_DHW_DEV_ID = 2;
export const SUB_PRODUCTS_WNS_DEV_ID = 3; // Wellness and Stimulation
export const SUB_PRODUCTS_TEARDOWN_REPORTS = 4;

export const SUB_PRODUCT_ORDERS = 'orders';
export const SUB_PRODUCT_ORDERS_SA = 'smoking-alternatives';
export const SUB_PRODUCT_ORDERS_WS = 'wellness-and-stimulation';
export const SUB_ORDERS_SA = 'orders-smoking-alternatives';
export const SUB_ORDERS_WS = 'orders-wellness-and-stimulation';
export const SUB_CUSTOMERS = CAT_CUSTOMERS;
export const SUB_PROJECTS = CAT_PROJECTS;
export const SUB_AGENTS = CAT_AGENTS;
export const SUB_COURIER_DELIVERY_SERVICES = CAT_COURIER_DELIVERY_SERVICES;
export const SUB_WEBSITE_DEALS = CAT_WEBSITE_DEALS;
export const SUB_WEBSITE_DEALS_DEALS = 'deals';
export const SUB_INFO_REQUESTS = CAT_INFO_REQUESTS;
export const SUB_ANALYZE_REQUESTS = CAT_ANALYZE_REQUESTS;
export const SUB_WEBSITE_SERVICES = CAT_WEBSITE_SERVICES;
export const SUB_WEBSITES = CAT_WEBSITES;
export const SUB_STATUSES = CAT_STATUSES;
export const SUB_ATTENDING_REQUESTS = CAT_ATTENDING_REQUESTS;
export const SUB_CORE_ACCOUNTS = 'core_accounts';

export const PRODUCTS_SUBCATEGORIES = [
  SUB_PRODUCTS_VAPING_DEV,
  SUB_PRODUCTS_DHW_DEV,
  SUB_PRODUCTS_WNS_DEV,
  TEARDOWN_REPORTS,
];
export const ORDERS_SUBCATEGORIES = [
  SUB_ORDERS_SA,
  SUB_ORDERS_WS,
  SUB_WEBSITE_DEALS,
  SUB_INFO_REQUESTS,
  SUB_ANALYZE_REQUESTS,
];

export const SUGGESTED_FILTER_TYPE = 'suggested';
export const COMMON_FILTER_TYPE = 'common';
export const PATENT_RESEARCH_FILTER_TYPE = 'patent_research';

export const USP_TYPE_ID = 36;

export const PRODUCT_REAL_CATEGORIES = [
  { id: SUB_PRODUCTS_VAPING_DEV_ID, role: ROLE_VAPING, alias: SUB_PRODUCTS_VAPING_DEV, title: 'Smoking Alternatives' },
  {
    id: SUB_PRODUCTS_DHW_DEV_ID,
    role: ROLE_DIGITAL_HEALTHCARE,
    alias: SUB_PRODUCTS_DHW_DEV,
    title: 'Digital Health and Wellbeing devices',
  },
  {
    id: SUB_PRODUCTS_WNS_DEV_ID,
    role: ROLE_WELLNESS_STIMULATION,
    alias: SUB_PRODUCTS_WNS_DEV,
    title: 'Wellness and Stimulation',
  },
];

export const PRODUCTS_SUBCATEGORIES_MAP = {
  [SUB_PRODUCTS_VAPING_DEV]: {
    title: 'Smoking Alternatives',
    id: SUB_PRODUCTS_VAPING_DEV_ID,
    requiredRoles: [ROLE_VAPING],
    slug: SUB_PRODUCTS_VAPING_DEV,
    customIcon: true,
  },
  [TEARDOWN_REPORTS]: {
    title: 'Teardown reports',
    id: SUB_PRODUCTS_VAPING_DEV_ID,
    parent: CAT_PRODUCTS,
    customIcon: true,
  },
  [PRODUCTS_CLASSIFICATION]: {
    title: 'Classification',
    id: SUB_PRODUCTS_VAPING_DEV_ID,
    parent: CAT_PRODUCTS,
    customIcon: true,
  },
  [SUB_PRODUCTS_DHW_DEV]: {
    hint: 'Digital Health and Wellbeing devices',
    title: 'DH&W devices',
    id: SUB_PRODUCTS_DHW_DEV_ID,
    requiredRoles: [ROLE_DIGITAL_HEALTHCARE],
    divider: true,
    slug: SUB_PRODUCTS_DHW_DEV,
    customIcon: true,
  },
  [SUB_PRODUCTS_WNS_DEV]: {
    hint: 'Wellness and Stimulation',
    title: 'W&S products',
    id: SUB_PRODUCTS_WNS_DEV_ID,
    requiredRoles: [ROLE_WELLNESS_STIMULATION],
    slug: SUB_PRODUCTS_WNS_DEV,
    customIcon: true,
  },
};

const SINGULAR_CATS = {
  [CAT_PRODUCTS]: 'product',
  assistant_products: 'product',
  [CAT_COMPANIES]: 'company',
  [CAT_BRANDS]: 'brand',
  [CAT_PATENT_RESEARCH]: 'patent_research',
  [CAT_TRADEMARKS]: 'trademark',
  [CAT_CONTACTS]: 'contact',
  [CAT_COMPONENTS]: 'component',
  [CAT_PATENTS]: 'patent',
  [CAT_NEWS]: 'news',
  [CAT_COMPANY_NEWS]: 'company news',
  [CAT_EVENTS]: 'event',
  [CAT_REPORTSARCHIVE]: 'reports archive',
  [CAT_STANDING_REPORTS]: 'standing report',
  [CAT_FILES]: 'file',
  [CAT_CONSUMABLE_VARIATIONS]: 'consumable variation',
  [CAT_ACTIVITY_SPHERES]: 'sphere of activity',
  [CAT_TYPES]: 'type',
  [CAT_VARIATIONS]: 'variation',
  [CAT_FEATURES]: 'feature',
  [CAT_EVENT_TYPES]: 'event type',
  [CAT_EVENT_THEMES]: 'event theme',
  [CAT_AI_NEWS_PROMPTS]: 'prompt',
  [CAT_SOCIAL_MEDIA_SCRAPER_CORE_ACCOUNTS]: 'core account',
  [CAT_SAMPLES]: 'sample',
  [CAT_SAMPLE_CONDITIONS]: 'sample condition',
  [CAT_BRAND_STAFF_STATISTICS]: 'brand staff statistics',
  [CAT_COMPANY_STAFF_STATISTICS]: 'company staff statistics',
  [CAT_CONTACT_STAFF_STATISTICS]: 'contact staff statistics',
  [CAT_PATENT_STAFF_STATISTICS]: 'patent staff statistics',
  [CAT_PRODUCT_STAFF_STATISTICS]: 'product staff statistics',
  [CAT_EVENT_STAFF_STATISTICS]: 'event staff statistics',
  [CAT_NEWS_STAFF_STATISTICS]: 'news staff statistics',
  [CAT_COMPONENTS_STAFF_STATISTICS]: 'component staff statistics',
  [CAT_BRAND_STAFF_ITEM_STATISTICS]: 'brand staff item statistics',
  [CAT_COMPANY_STAFF_ITEM_STATISTICS]: 'company staff item statistics',
  [CAT_CONTACT_STAFF_ITEM_STATISTICS]: 'contact staff item statistics',
  [CAT_PATENT_STAFF_ITEM_STATISTICS]: 'patent staff item statistics',
  [CAT_PRODUCT_STAFF_ITEM_STATISTICS]: 'product staff item statistics',
  [CAT_EVENT_STAFF_ITEM_STATISTICS]: 'event staff item statistics',
  [CAT_NEWS_STAFF_ITEM_STATISTICS]: 'news staff item statistics',
  [CAT_RESEARCHE_STAFF_ITEM_STATISTICS]: 'research staff item statistics',
  [CAT_RESEARCHE_STAFF_STATISTICS]: 'research staff statistics',
  [CAT_COMPONENTS_STAFF_ITEM_STATISTICS]: 'component staff item statistics',
  [CAT_COMPONENT_PACKAGES]: 'component package',
  [CAT_COMPONENT_CATEGORIES]: 'component category',
  [CAT_USERS]: 'user',
  [CAT_RESEARCHES]: 'research',
  [CAT_USERGROUPS]: 'user group',
  [CAT_PRODUCT_ORDERS]: 'order',
  [CAT_CUSTOMERS]: 'customer',
  [CAT_COURIER_DELIVERY_SERVICES]: 'delivery service',
  [CAT_PROJECTS]: 'project',
  [CAT_AGENTS]: 'agent',
  [CAT_RECOMMENDED_PRODUCTS]: 'recommended product',
  [CAT_ORDER_AGENTS]: 'agent payments',
  [CAT_WEBSITE_SERVICES]: 'website service',
  [CAT_SOCIAL_MEDIA_SCRAPER_INSTAGRAM]: 'social media scraper instagram',
  [CAT_PATENT_RESEARCH_STAFF_ITEM_STATISTICS]: 'patent research staff item statistics',
  [CAT_PATENT_RESEARCH_STAFF_STATISTICS]: 'patent research staff statistics',
  [CAT_TRADEMARKS_STAFF_STATISTICS]: 'trademark staff statistics',
  [CAT_TRADEMARKS_STAFF_ITEM_STATISTICS]: 'trademark staff item statistics',
};

export function singularizeCat(cat) {
  return SINGULAR_CATS[cat] || cat;
}

// Unlike `singularizeCat`, an unknown category yields undefined instead of the raw key,
// so callers can tell a real label from a category name that would read as gibberish.
export function getSingularCat(cat) {
  return SINGULAR_CATS[cat];
}

export const categories = new Set([CAT_CONTACTS, CAT_PATENTS, CAT_SAMPLES]);

export const searchEntities = new Set([
  CAT_PRODUCTS,
  CAT_BRANDS,
  CAT_CONTACTS,
  CAT_COMPANIES,
  CAT_TRADEMARKS,
  CAT_PATENTS,
]);

export const cmsCategories = new Set([
  CAT_PRODUCTS,
  CAT_STANDING_REPORTS,
  CAT_COMPANIES,
  CAT_BRANDS,
  CAT_PATENT_RESEARCH,
  CAT_TRADEMARKS,
  CAT_CONTACTS,
  CAT_COMPONENTS,
  CAT_SAMPLES,
  CAT_FILES,
  CAT_NEWS,
  CAT_CONSUMABLE_VARIATIONS,
  CAT_TYPES,
  CAT_SAMPLE_CONDITIONS,
  CAT_FEATURES,
  CAT_EVENTS,
  CAT_EVENT_TYPES,
  CAT_EVENT_THEMES,
  CAT_ACTIVITY_SPHERES,
  CAT_USERS,
  CAT_RESEARCHES,
  CAT_PRODUCT_ORDERS,
  CAT_CUSTOMERS,
  CAT_PROJECTS,
  CAT_COURIER_DELIVERY_SERVICES,
  CAT_AGENTS,
  CAT_ORDER_AGENTS,
  CAT_RECOMMENDED_PRODUCTS,
  CAT_WEBSITE_DEALS,
  CAT_INFO_REQUESTS,
  CAT_WEBSITE_SERVICES,
  CAT_WEBSITES,
  CAT_STATUSES,
  CAT_ANALYZE_REQUESTS,
  CAT_AI_NEWS_PROMPTS,
  CAT_ATTENDING_REQUESTS,
  CAT_INFORMATION_SOURCES,
  CAT_INFORMATION_SOURCE_SNAPSHOTS,
  CAT_SOCIAL_MEDIA_SCRAPER_CORE_ACCOUNTS,
]);

export const CMS_TAB_PRODS_DRAFT = 'products_draft';
export const CMS_TAB_PRODS = CAT_PRODUCTS;
export const CMS_TAB_CRM = 'crm';
export const CMS_TAB_PRODUCT_ORDERS = CAT_PRODUCT_ORDERS;
export const CMS_TAB_CUSTOMERS = CAT_CUSTOMERS;
export const CMS_TAB_COURIER_DELIVERY_SERVICES = CAT_COURIER_DELIVERY_SERVICES;
export const CMS_TAB_PROJECTS = CAT_PROJECTS;
export const CMS_TAB_AGENTS = CAT_AGENTS;
export const CMS_TAB_RECOMMENDED_PRODUCTS = CAT_RECOMMENDED_PRODUCTS;
export const CMS_TAB_BRANDS = CAT_BRANDS;
export const CMS_TAB_PATENT_RESEARCH = 'patent_research';
export const CMS_TAB_COMPANIES = CAT_COMPANIES;
export const CMS_TAB_COMPANIES_DRAFT = 'companies_draft';
export const CMS_TAB_STANDING_REPORTS = CAT_STANDING_REPORTS;
export const CMS_TAB_FILES = CAT_FILES;
export const CMS_TAB_SAMPLES = CAT_SAMPLES;
export const CMS_TAB_REF_DATA = 'ref_data';
export const CMS_TAB_STATS = 'stats_reports';
export const CMS_TAB_COMPONENTS = CAT_COMPONENTS;
export const CMS_TAB_CONTACTS = CAT_CONTACTS;
export const CMS_TAB_TRADEMARKS = CAT_TRADEMARKS;
export const CMS_TAB_NEWS = CAT_NEWS;
export const CMS_TAB_EVENTS = CAT_EVENTS;
export const CMS_TAB_USERS = CAT_USERS;
export const CMS_TAB_RESEARCHES = CAT_RESEARCHES;
export const CMS_TAB_EVENT_TYPES = CAT_EVENTS;
export const CMS_TAB_EVENT_THEMES = CAT_EVENT_THEMES;
export const CMS_TAB_INFORMATION_SOURCES = CAT_INFORMATION_SOURCES;
export const CMS_SUB_TAB_COMPONENTS_DRAFT = 'sub_components_draft';
export const CMS_SUB_TAB_COMPONENTS = 'sub_components';
export const CMS_SUB_TAB_EVENTS_THEMES = 'sub_event_themes';

export const CMS_TABS = [
  {
    id: CMS_TAB_PRODS_DRAFT,
    cat: null,
    title: 'Products Draft',
    filter: { draft: true },
    defSubTab: SUB_PRODUCTS_VAPING_DEV,
    editCat: CAT_PRODUCTS,
  },
  {
    id: CMS_TAB_PRODS,
    cat: null,
    title: 'Products',
    filter: { draft: false },
    defSubTab: SUB_PRODUCTS_VAPING_DEV,
    editCat: CAT_PRODUCTS,
  },
  {
    id: CMS_TAB_RECOMMENDED_PRODUCTS,
    cat: CAT_RECOMMENDED_PRODUCTS,
    title: 'Recommended Products',
    editCat: CAT_RECOMMENDED_PRODUCTS,
    requiredRoles: [ROLE_RECOMMENDED_PRODUCTS, ROLE_STAFF],
  },
  {
    id: CMS_TAB_CRM,
    cat: null,
    defSubTab: SUB_ORDERS_SA,
    title: 'CRM',
    requiredRoles: [ROLE_LOGISTIC_MANGER, ROLE_LOGISTIC_MANGER_READ],
  },
  { id: CMS_TAB_BRANDS, cat: CAT_BRANDS, title: 'Brands' },
  {
    id: CMS_TAB_PATENT_RESEARCH,
    cat: CAT_PATENT_RESEARCH,
    title: 'Patent research',
    requiredRoles: [ROLE_PATENT_SPECIALIST],
  },
  {
    id: CMS_TAB_COMPANIES_DRAFT,
    cat: CAT_COMPANIES,
    filter: { draft: true },
    title: 'Companies Draft',
  },
  // { id: CMS_TAB_COMPANIES, cat: CAT_COMPANIES, title: 'Companies' },
  {
    id: null,
    cat: null,
    title: 'Teardown reports',
    isExternal: true,
    href: 'https://teardown-report.winglegroup.com/',
  },
  {
    id: CMS_TAB_STANDING_REPORTS,
    cat: CAT_STANDING_REPORTS,
    title: 'Standing Reports',
  },
  { id: CMS_TAB_RESEARCHES, cat: CAT_RESEARCHES, title: 'Research' },
  { id: CMS_TAB_FILES, cat: CAT_FILES, title: 'Files' },
  { id: CMS_TAB_SAMPLES, cat: CAT_SAMPLES, title: 'Samples', hidden: true },
  { id: CMS_TAB_NEWS, cat: CAT_NEWS, title: 'News' },
  { id: CMS_TAB_EVENTS, cat: CAT_EVENTS, title: 'Events', defSubTab: CMS_TAB_EVENT_THEMES },
  {
    id: CMS_TAB_REF_DATA,
    cat: null,
    title: 'Reference Data',
    defSubTab: CAT_CONSUMABLE_VARIATIONS,
  },
  {
    id: CMS_TAB_STATS,
    cat: null,
    title: 'Statistics reports',
    hideActions: true,
  },
  {
    id: CMS_TAB_COMPONENTS,
    cat: null,
    title: 'Components',
    defSubTab: CMS_SUB_TAB_COMPONENTS_DRAFT,
    editCat: CAT_COMPONENTS,
  },
  { id: CMS_TAB_CONTACTS, cat: CAT_CONTACTS, title: 'Contacts' },
  { id: CMS_TAB_TRADEMARKS, cat: CAT_TRADEMARKS, title: 'Trademarks' },
  {
    id: null,
    cat: null,
    title: 'Samples',
    children: [
      { id: CMS_TAB_SAMPLES, cat: CAT_SAMPLES, title: 'Samples' },
      {
        id: null,
        cat: null,
        title: 'External Samples',
        isExternal: true,
        href: 'https://storage.vape.museum/',
      },
    ],
  },
  { id: CMS_TAB_USERS, cat: CAT_USERS, title: 'Users' },
  {
    id: null,
    cat: null,
    title: 'Apps & Services',
    children: [
      {
        id: CMS_TAB_INFORMATION_SOURCES,
        cat: CAT_INFORMATION_SOURCES,
        title: 'Products Information Sources',
        isExternal: false,
      },
      {
        id: 'social-media-scraper',
        cat: null,
        title: 'Social media scraper',
        isExternal: false,
        href: 'social-media-scraper',
      },
      {
        id: null,
        cat: null,
        title: 'Social media scraper panel',
        isExternal: true,
        href: 'https://sm-panel.winglegroup.com',
      },
      {
        id: 'newsletter-emails',
        cat: null,
        title: 'Newsletter emails',
        isExternal: false,
        href: 'newsletter-emails',
      },
      {
        id: null,
        cat: null,
        title: 'Visualizer (Relations graph)',
        isExternal: true,
        href: 'https://visualizer.winglegroup.com/',
      },
      {
        id: null,
        cat: null,
        title: 'Research app',
        isExternal: true,
        href: 'https://scholar-app.winglegroup.com',
      },
      {
        id: null,
        cat: null,
        title: 'News app',
        isExternal: true,
        href: 'https://news-app.winglegroup.com',
      },
      {
        id: null,
        cat: null,
        title: 'Patents app',
        isExternal: true,
        href: 'https://patent-app.winglegroup.com',
      },
      {
        id: null,
        cat: null,
        title: 'Trademarks app',
        isExternal: true,
        href: 'https://trademark-app.winglegroup.com/',
      },
      {
        id: null,
        cat: null,
        title: 'Wayback Machine',
        isExternal: true,
        href: 'https://wayback_machine.winglegroup.com/',
      },
      {
        id: null,
        cat: null,
        title: 'Image extractor',
        isExternal: true,
        href: 'https://images-extractor.winglegroup.com/docs',
      },
      {
        id: null,
        cat: null,
        title: 'Search by image',
        isExternal: true,
        href: 'https://image-based-product-search.winglegroup.com/doc',
      },
      {
        id: null,
        cat: null,
        title: 'Text-recognition',
        isExternal: true,
        href: 'https://text-recognition.winglegroup.com/doc',
      },
    ],
  },
];

const productSubTabs = (commonId, title, draft) => {
  return PRODUCTS_SUBCATEGORIES.map((cat) => {
    const { id, title, requiredRoles, customIcon } = PRODUCTS_SUBCATEGORIES_MAP[cat];
    return {
      id: cat,
      cat: CAT_PRODUCTS,
      filter: { draft, 'category.id': id },
      title,
      requiredRoles,
      categoryId: id,
      customIcon,
    };
  });
};

export const CMS_SUB_TABS = {
  [CMS_TAB_REF_DATA]: [
    {
      id: CAT_CONSUMABLE_VARIATIONS,
      cat: CAT_CONSUMABLE_VARIATIONS,
      title: 'Consumable Variations',
      icon: mdiFlaskOutline,
    },
    { id: CAT_TYPES, cat: CAT_TYPES, title: 'Product Types', icon: mdiShapeOutline },
    {
      id: CAT_SAMPLE_CONDITIONS,
      cat: CAT_SAMPLE_CONDITIONS,
      title: 'Samples Conditions',
      icon: mdiClipboardCheckOutline,
    },
    {
      id: CAT_FEATURES,
      cat: CAT_FEATURES,
      title: 'Features',
      icon: mdiFeatureSearchOutline,
    },
    {
      id: CAT_ACTIVITY_SPHERES,
      cat: CAT_ACTIVITY_SPHERES,
      title: 'Spheres of activity',
      icon: mdiBriefcaseOutline,
    },
    {
      id: CAT_EVENT_TYPES,
      cat: CAT_EVENT_TYPES,
      title: 'Event Types',
      icon: mdiCalendarTextOutline,
    },
    {
      id: CAT_EVENT_THEMES,
      cat: CAT_EVENT_THEMES,
      title: 'Event Themes',
      icon: mdiTagMultipleOutline,
    },
    {
      id: CAT_AI_NEWS_PROMPTS,
      cat: CAT_AI_NEWS_PROMPTS,
      title: 'Prompts',
      icon: mdiRobotOutline,
      requiredRoles: [ROLE_ADMIN, ROLE_PROMPTS_MANAGER],
    },
    {
      id: SUB_CORE_ACCOUNTS,
      cat: CAT_SOCIAL_MEDIA_SCRAPER_CORE_ACCOUNTS,
      title: 'Core accounts',
      icon: mdiAccountMultiple,
    },
  ],
  [CMS_TAB_CRM]: [
    {
      id: SUB_ORDERS_SA,
      cat: CAT_PRODUCT_ORDERS,
      title: 'Orders SA',
      icon: mdiCartOutline,
      requiredRoles: [ROLE_VAPING, ROLE_LOGISTIC_MANGER, ROLE_LOGISTIC_MANGER_READ],
      hasSubTabs: true,
    },
    {
      id: SUB_ORDERS_WS,
      cat: CAT_PRODUCT_ORDERS,
      title: 'Orders WS',
      icon: mdiCartOutline,
      requiredRoles: [ROLE_WELLNESS_STIMULATION, ROLE_LOGISTIC_MANGER, ROLE_LOGISTIC_MANGER_READ],
      hasSubTabs: true,
    },
    {
      id: SUB_WEBSITE_DEALS,
      cat: CAT_WEBSITE_DEALS,
      title: 'Website deals',
      icon: mdiWeb,
      requiredRoles: [ROLE_LOGISTIC_MANGER, ROLE_LOGISTIC_MANGER_READ],
      hasSubTabs: true,
    },
    {
      id: SUB_INFO_REQUESTS,
      cat: CAT_INFO_REQUESTS,
      title: 'Info Requests',
      icon: mdiInformationOutline,
      requiredRoles: [ROLE_LOGISTIC_MANGER, ROLE_LOGISTIC_MANGER_READ],
    },
    {
      id: SUB_ANALYZE_REQUESTS,
      cat: CAT_ANALYZE_REQUESTS,
      title: 'Analyze requests',
      icon: mdiChartLine,
      requiredRoles: [ROLE_LOGISTIC_MANGER, ROLE_LOGISTIC_MANGER_READ],
    },
    {
      id: SUB_ATTENDING_REQUESTS,
      cat: CAT_ATTENDING_REQUESTS,
      title: 'Attending requests',
      icon: mdiHeadset,
      requiredRoles: [ROLE_LOGISTIC_MANGER, ROLE_LOGISTIC_MANGER_READ],
    },
  ],
  [CMS_TAB_COMPONENTS]: [
    {
      id: CMS_SUB_TAB_COMPONENTS_DRAFT,
      cat: CAT_COMPONENTS,
      title: 'Components Draft',
      icon: mdiCubeOutline,
      filter: { draft: true },
    },
    {
      id: CMS_SUB_TAB_COMPONENTS,
      cat: CAT_COMPONENTS,
      title: 'Components',
      icon: mdiCube,
      filter: { draft: false },
    },
  ],
  [CMS_TAB_PRODS_DRAFT]: productSubTabs(null, 'All Drafts', true),
  [CMS_TAB_PRODS]: productSubTabs(null, 'All Products', false),
  [SUB_ORDERS_SA + '_nested']: [
    {
      id: SUB_PRODUCT_ORDERS,
      cat: CAT_PRODUCT_ORDERS,
      title: 'Orders',
      requiredRoles: [ROLE_LOGISTIC_MANGER, ROLE_LOGISTIC_MANGER_READ, ROLE_VAPING],
    },
    {
      id: SUB_CUSTOMERS,
      cat: CAT_CUSTOMERS,
      title: 'Customers',
      requiredRoles: [ROLE_LOGISTIC_MANGER, ROLE_LOGISTIC_MANGER_READ],
    },
    {
      id: SUB_COURIER_DELIVERY_SERVICES,
      cat: CAT_COURIER_DELIVERY_SERVICES,
      title: 'Delivery services',
      requiredRoles: [ROLE_LOGISTIC_MANGER, ROLE_LOGISTIC_MANGER_READ],
    },
    {
      id: SUB_PROJECTS,
      cat: CAT_PROJECTS,
      title: 'Projects',
      requiredRoles: [ROLE_LOGISTIC_MANGER, ROLE_LOGISTIC_MANGER_READ],
    },
    {
      id: SUB_AGENTS,
      cat: CAT_AGENTS,
      title: 'Agents',
      requiredRoles: [ROLE_LOGISTIC_MANGER, ROLE_LOGISTIC_MANGER_READ],
    },
  ],
  [SUB_ORDERS_WS + '_nested']: [
    {
      id: SUB_PRODUCT_ORDERS,
      cat: CAT_PRODUCT_ORDERS,
      title: 'Orders',
      requiredRoles: [ROLE_LOGISTIC_MANGER, ROLE_LOGISTIC_MANGER_READ, ROLE_WELLNESS_STIMULATION],
    },
    {
      id: SUB_CUSTOMERS,
      cat: CAT_CUSTOMERS,
      title: 'Customers',
      requiredRoles: [ROLE_LOGISTIC_MANGER, ROLE_LOGISTIC_MANGER_READ],
    },
    {
      id: SUB_COURIER_DELIVERY_SERVICES,
      cat: CAT_COURIER_DELIVERY_SERVICES,
      title: 'Delivery services',
      requiredRoles: [ROLE_LOGISTIC_MANGER, ROLE_LOGISTIC_MANGER_READ],
    },
    {
      id: SUB_PROJECTS,
      cat: CAT_PROJECTS,
      title: 'Projects',
      requiredRoles: [ROLE_LOGISTIC_MANGER, ROLE_LOGISTIC_MANGER_READ],
    },
    {
      id: SUB_AGENTS,
      cat: CAT_AGENTS,
      title: 'Agents',
      requiredRoles: [ROLE_LOGISTIC_MANGER, ROLE_LOGISTIC_MANGER_READ],
    },
  ],
  website_deals_nested: [
    {
      id: SUB_WEBSITE_DEALS_DEALS,
      cat: CAT_WEBSITE_DEALS,
      title: 'Deals',
      requiredRoles: [ROLE_LOGISTIC_MANGER, ROLE_LOGISTIC_MANGER_READ],
    },
    {
      id: SUB_WEBSITES,
      cat: CAT_WEBSITES,
      title: 'Websites',
      requiredRoles: [ROLE_ADMIN],
    },
    {
      id: SUB_WEBSITE_SERVICES,
      cat: CAT_WEBSITE_SERVICES,
      title: 'Services',
      requiredRoles: [ROLE_ADMIN],
    },
    {
      id: SUB_STATUSES,
      cat: CAT_STATUSES,
      title: 'Statuses',
      requiredRoles: [ROLE_ADMIN],
    },
    {
      id: SUB_CUSTOMERS,
      cat: CAT_CUSTOMERS,
      title: 'Customers',
      requiredRoles: [ROLE_LOGISTIC_MANGER, ROLE_LOGISTIC_MANGER_READ],
    },
  ],
};

// Core accounts are reachable from two sections; the editor must stay in the one the
// user came from, so its path is derived from the active route tab.
export const getCoreAccountsPath = (tab) =>
  tab === CMS_TAB_REF_DATA ? `${CMS_TAB_REF_DATA}/${SUB_CORE_ACCOUNTS}` : 'social-media-scraper/accounts';

export const subCatsMap = new Map(
  Object.entries(CMS_SUB_TABS).reduce((acc, [tab, subTabs]) => {
    for (const sub of subTabs) {
      acc.push([sub.cat, { tab, sub: sub.id }]);
    }
    return acc;
  }, [])
);

export const STATS_CATEGORIES_MAP = {
  [CAT_BRANDS]: {
    id: CAT_BRAND_STAFF_STATISTICS,
    title: 'Brands',
    itemCat: CAT_BRAND_STAFF_ITEM_STATISTICS,
  },
  [CAT_COMPANIES]: {
    id: CAT_COMPANY_STAFF_STATISTICS,
    title: 'Companies',
    itemCat: CAT_COMPANY_STAFF_ITEM_STATISTICS,
  },
  [CAT_COMPONENTS]: {
    id: CAT_COMPONENTS_STAFF_STATISTICS,
    title: 'Components',
    itemCat: CAT_COMPONENTS_STAFF_ITEM_STATISTICS,
  },
  [CAT_CONTACTS]: {
    id: CAT_CONTACT_STAFF_STATISTICS,
    title: 'Contacts',
    itemCat: CAT_CONTACT_STAFF_ITEM_STATISTICS,
  },
  [CAT_PATENTS]: {
    id: CAT_PATENT_STAFF_STATISTICS,
    title: 'Patents',
    itemCat: CAT_PATENT_STAFF_ITEM_STATISTICS,
  },
  [CAT_PRODUCTS]: {
    id: CAT_PRODUCT_STAFF_STATISTICS,
    title: 'Products',
    itemCat: CAT_PRODUCT_STAFF_ITEM_STATISTICS,
  },
  [CAT_EVENTS]: {
    id: CAT_EVENT_STAFF_STATISTICS,
    title: 'Events',
    itemCat: CAT_EVENT_STAFF_ITEM_STATISTICS,
  },
  [CAT_NEWS]: {
    id: CAT_NEWS_STAFF_STATISTICS,
    title: 'News',
    itemCat: CAT_NEWS_STAFF_ITEM_STATISTICS,
  },
  [CAT_RESEARCHES]: {
    id: CAT_RESEARCHE_STAFF_STATISTICS,
    title: 'Research',
    itemCat: CAT_RESEARCHE_STAFF_ITEM_STATISTICS,
  },
  [CAT_PATENT_RESEARCH]: {
    id: CAT_PATENT_RESEARCH_STAFF_STATISTICS,
    title: 'Patent research',
    itemCat: CAT_PATENT_RESEARCH_STAFF_ITEM_STATISTICS,
  },
  [CAT_TRADEMARKS]: {
    id: CAT_TRADEMARKS_STAFF_STATISTICS,
    title: 'Trademarks',
    itemCat: CAT_TRADEMARKS_STAFF_ITEM_STATISTICS,
  },
};

/**
 *
 * @type {Map<string, string>}
 */
export const CATS_PATH_MAP = new Map([
  [CAT_BRANDS, '/api/brands'],
  [CAT_BRAND_STAFF_STATISTICS, '/api/brand_staff_statistics'],
  [CAT_COMPANIES, '/api/companies'],
  [CAT_COMPANY_STAFF_STATISTICS, '/api/company_staff_statistics'],
  [CAT_COMPONENTS, '/api/components'],
  [CAT_COMPONENTS_STAFF_STATISTICS, '/api/component_staff_statistics'],
  [CAT_CONTACTS, '/api/contacts'],
  [CAT_CONTACT_STAFF_STATISTICS, '/api/contact_staff_statistics'],
  [CAT_FILES, '/api/files'],
  [CAT_NEWS, '/api/news'],
  [CAT_COMPANY_NEWS, '/api/news'],
  [CAT_AI_NEWS, '/api/news'],
  [CAT_PATENTS, '/api/patents'],
  [CAT_PATENT_STAFF_STATISTICS, '/api/patent_staff_statistics'],
  [CAT_PRODUCTS, '/api/products'],
  [CAT_PRODUCT_STAFF_STATISTICS, '/api/product_staff_statistics'],
  [CAT_EVENT_STAFF_STATISTICS, '/api/event_staff_statistics'],
  [CAT_NEWS_STAFF_STATISTICS, '/api/news_staff_statistics'],
  [CAT_RESEARCHE_STAFF_STATISTICS, '/api/research_staff_statistics'],
  [CAT_STANDING_REPORTS, '/api/reports'],
  [CAT_TRADEMARKS, '/api/trademark_items'],
  [CAT_EVENTS, '/api/events'],
  [CAT_RESEARCHES, '/api/researches'],
  [CAT_SOCIAL_MEDIA_SCRAPER_INSTAGRAM, '/api/instagram/results'],
  [CAT_SOCIAL_MEDIA_SCRAPER_FACEBOOK, '/api/facebook/results'],
  [CAT_SOCIAL_MEDIA_SCRAPER_X, '/api/x/results'],
  [CAT_SOCIAL_MEDIA_SCRAPER_YOUTUBE, '/api/youtube/results'],
  [CAT_SOCIAL_MEDIA_SCRAPER_LINKEDIN, '/api/linkedin/results'],
  [CAT_SOCIAL_MEDIA_SCRAPER_ALL, '/api/all/results'],
  [CAT_SOCIAL_MEDIA_SCRAPER_CORE_ACCOUNTS, '/api/core-accounts'],
  [CAT_SOCIAL_MEDIA_SCRAPER_CORE_RESULTS, '/api/core/results'],
  [CAT_SOCIAL_MEDIA_SCRAPER_CORE_SESSIONS, '/api/core/sessions'],
  [CAT_NEWSLETTER_EMAILS, '/api/messages'],
  [CAT_NEWSLETTER_DOMAINS, '/api/domains'],
  [CAT_VARIATIONS, '/api/product_variations'],
  [CAT_INFORMATION_SOURCES, '/api/information_sources'],
  [CAT_INFORMATION_SOURCE_SNAPSHOTS, '/api/information_source_snapshots'],
  [CAT_PATENT_RESEARCH_STAFF_STATISTICS, '/api/patent_research_staff_statistics'],
  [CAT_TRADEMARKS_STAFF_STATISTICS, '/api/trademark_staff_item_statistics'],
]);

export const TRACK_SESSION_TIME_CATS = new Set([
  CAT_BRANDS,
  CAT_COMPANIES,
  CAT_COMPONENTS,
  CAT_CONTACTS,
  CAT_PRODUCTS,
  CAT_FILES,
  CAT_TRADEMARKS,
  CAT_NEWS,
  CAT_EVENTS,
  CAT_RESEARCHES,
  CAT_PATENT_RESEARCH,
]);

export const CACHED_DATA_MEDIA_RESOURCE_TYPES = 'mediaResourceTypes';
export const CACHED_DATA_MODULES = 'modules';
export const CACHED_DATA_STAFF = 'staff';
export const CACHED_DATA_STAFF_TRACKED = 'trackedStaff';
export const CACHED_DATA_PATENTS_AMOUNT = 'patentsAmount';
export const CACHED_DATA_CATEGORIES = 'categories';

export const PROPS_PRODUCTS = [
  'id',
  'name',
  'productionStatus',
  'defaultImage',
  'types',
  'draft',
  'appeared',
  'category',
  'launchRegion',
  'brands',
  'manufacturers',
  'numberOfReports',
  'marketCountries',
  'uspTypes',
  'aiReady',
];

export const PROPS_TRADEMARKS = [
  'id',
  'name',
  'holders',
  'originOffice',
  'registrationOffice',
  'defaultImage',
  'niceClasses',
  'status',
  'expirationDate',
  'registrationDate',
  'registrationNumber',
  'applicationNumber',
  'applicationDate',
  'externalId',
  'types',
];

export const PROPS_CMS_TRADEMARKS = [
  'id',
  'name',
  'holders',
  'originOffice',
  'registrationOffice',
  'niceClasses',
  'status',
];

export const PROPS_COMPANIES = [
  'id',
  'defaultImage',
  'name',
  'location',
  'region',
  'numberOfBrands',
  'numberOfProducts',
  'categories',
  'draft',
  'types',
];

export const PROPS_BRANDS = [
  'id',
  'defaultImage',
  'name',
  'ownerCompanies',
  'numberOfCompanies',
  'numberOfProducts',
  'categories',
];

export const PROPS_PATENTS = [
  'inventionTitles',
  'country',
  'docNumber',
  'kind',
  'publication',
  'application',
  'id',
  'relevant',
];

export const PROPS_EVENTS = [
  'logo',
  'important',
  'name',
  'startedOn',
  'finishedOn',
  'visitation',
  'id',
  'hasReports',
  'categories',
];

export const PROPS_RESEARCHES = [
  'name',
  'summary',
  'url',
  'authors',
  'category',
  'file',
  'publishedOn',
  'id',
  'status',
  'content',
  'shortSummary',
];

export const PROPS_CMS_RESEARCHES = [
  'name',
  'summary',
  'url',
  'authors',
  'category',
  'file',
  'publishedOn',
  'id',
  'status',
  'researchCategories',
  'domain',
  'content',
  'info',
];

export const NO_STANDING_REPORTS = [
  CAT_BRANDS,
  CAT_PATENTS,
  CAT_TRADEMARKS,
  CAT_CONTACTS,
  CAT_COMPANY_NEWS,
  CAT_STANDING_REPORTS,
  CAT_AI_NEWS,
  CAT_VARIATIONS,
];

export const PLACEHOLDERS_BY_CATEGORY = {
  [CAT_PRODUCTS]: {
    default: 'searchModule.products.default',
    spec: 'searchModule.products.spec',
    strict: 'searchModule.products.strict',
    specStrict: 'searchModule.products.specStrict',
    specDesc: 'searchModule.products.specDesc',
    description: 'searchModule.products.description',
  },
  [CAT_COMPONENTS]: 'searchModule.components',
  [CAT_COMPANIES]: Object.assign(
    (isStaff, isCustomer, isVaping, routeParams) => {
      if (isStaff) {
        return 'searchModule.companies.staff';
      }
      if (isCustomer && isVaping && routeParams?.subcategory === 'smoking-alternatives') {
        return 'searchModule.companies.staff';
      }
      return 'searchModule.companies.customer';
    },
    {
      description: 'searchModule.companies.description',
    }
  ),
  [CAT_CONTACTS]: 'searchModule.contacts',
  [CAT_TRADEMARKS]: 'searchModule.trademarks',
  [CAT_BRANDS]: 'searchModule.brands',
  [CAT_PATENTS]: Object.assign(
    (hasRole) => (hasRole ? 'searchModule.patents.hasRole' : 'searchModule.patents.noRole'),
    {
      claims: 'searchModule.patents.claims',
      description: 'searchModule.patents.description',
      claimsDescription: 'searchModule.patents.claimsDescription',
    }
  ),
  [CAT_EVENTS]: 'searchModule.events',
  [CAT_STANDING_REPORTS]: 'searchModule.standing_reports',
  [CAT_RESEARCHES]: (isCMS) => {
    return isCMS ? 'searchModule.research.cms' : 'searchModule.research.default';
  },
  [CAT_COMPANY_NEWS]: 'searchModule.company_news',
  [CAT_FEATURE_OPTIONS]: 'searchModule.feature_options',
  [CAT_AI_NEWS]: 'searchModule.ai_news',
  [CAT_SOCIAL_MEDIA_SCRAPER_INSTAGRAM]: 'searchModule.instagram',
  [CAT_SOCIAL_MEDIA_SCRAPER_FACEBOOK]: 'searchModule.facebook',
  [CAT_SOCIAL_MEDIA_SCRAPER_X]: 'searchModule.x',
  [CAT_SOCIAL_MEDIA_SCRAPER_YOUTUBE]: 'searchModule.youtube',
  [CAT_SOCIAL_MEDIA_SCRAPER_LINKEDIN]: 'searchModule.linkedin',
  [CAT_SOCIAL_MEDIA_SCRAPER_ALL]: 'searchModule.all',
  [CAT_SOCIAL_MEDIA_SCRAPER_CORE_RESULTS]: 'searchModule.core_results',
  [CAT_NEWSLETTER_EMAILS]: 'searchModule.newsletter-emails',
  [CAT_NEWSLETTER_DOMAINS]: 'searchModule.newsletter-domains',
  [CAT_NEWS]: 'searchModule.news',
  [CAT_VARIATIONS]: {
    default: 'searchModule.variations.default',
    decodedFlavors: 'searchModule.variations.decodedFlavors',
    description: 'searchModule.variations.description',
    flavorClaims: 'searchModule.variations.flavorClaims',
    chemicalFormula: 'searchModule.variations.chemicalFormula',
    // pairs
    decodedFlavors_description: 'searchModule.variations.decodedFlavors_description',
    decodedFlavors_flavorClaims: 'searchModule.variations.decodedFlavors_flavorClaims',
    decodedFlavors_chemicalFormula: 'searchModule.variations.decodedFlavors_chemicalFormula',
    description_flavorClaims: 'searchModule.variations.description_flavorClaims',
    description_chemicalFormula: 'searchModule.variations.description_chemicalFormula',
    flavorClaims_chemicalFormula: 'searchModule.variations.flavorClaims_chemicalFormula',
    // triples
    decodedFlavors_description_flavorClaims: 'searchModule.variations.decodedFlavors_description_flavorClaims',
    decodedFlavors_description_chemicalFormula: 'searchModule.variations.decodedFlavors_description_chemicalFormula',
    decodedFlavors_flavorClaims_chemicalFormula: 'searchModule.variations.decodedFlavors_flavorClaims_chemicalFormula',
    description_flavorClaims_chemicalFormula: 'searchModule.variations.description_flavorClaims_chemicalFormula',
    // all
    decodedFlavors_description_flavorClaims_chemicalFormula:
      'searchModule.variations.decodedFlavors_description_flavorClaims_chemicalFormula',
  },
  [CAT_PRODUCT_ORDERS]: 'searchModule.orders',
  [CAT_WEBSITE_DEALS]: 'searchModule.website_deals',
  [CAT_INFO_REQUESTS]: 'searchModule.info_requests',
  [CAT_ANALYZE_REQUESTS]: 'searchModule.analyze_requests',
  [CAT_WEBSITE_SERVICES]: 'searchModule.website_services',
  [CAT_STATUSES]: 'searchModule.statuses',
  [CAT_CUSTOMERS]: 'searchModule.customers',
  [CAT_COURIER_DELIVERY_SERVICES]: 'searchModule.courier_delivery_services',
  [CAT_PROJECTS]: 'searchModule.projects',
  [CAT_AGENTS]: 'searchModule.agents',
  [CAT_ATTENDING_REQUESTS]: 'searchModule.attending_requests',
  [CAT_FILES]: 'searchModule.files',
  [CAT_CONSUMABLE_VARIATIONS]: 'searchModule.consumable_variations',
  [CAT_ACTIVITY_SPHERES]: 'searchModule.activity_spheres',
  [CAT_TYPES]: 'searchModule.types',
  [CAT_FEATURES]: 'searchModule.features',
  [CAT_AI_NEWS_PROMPTS]: 'searchModule.ai_news_prompts',
  [CAT_SAMPLES]: 'searchModule.samples',
  [CAT_INFORMATION_SOURCES]: 'searchModule.information_sources',
};

export const PRODUCT_SUB_CATEGORIES_FOR_TABLE = {
  [SUB_PRODUCTS_VAPING_DEV_ID]: {
    abbr: 'SA',
    tooltip: 'Smoking Alternatives',
  },
  [SUB_PRODUCTS_DHW_DEV_ID]: {
    abbr: 'DH&W',
    tooltip: 'Digital Health And Wellbeing Device',
  },
  [SUB_PRODUCTS_WNS_DEV_ID]: {
    abbr: 'W&S',
    tooltip: 'Wellness And Stimulation',
  },
};

export const ALLOWED_FILE_TYPES = [
  'jpg',
  'jpeg',
  'png',
  'webp',
  'pdf',
  'txt',
  'doc',
  'docx',
  'odt',
  'rtf',
  'md',
  'xls',
  'xlsx',
  'csv',
  'ods',
  'ppt',
  'pptx',
  'odp',
  'zip',
];

export const ALLOWED_EVIDENCE_FILE_TYPES = [...ALLOWED_FILE_TYPES, 'heic', 'heif'];

export const ALLOWED_IMAGE_TYPES = ['jpg', 'jpeg', 'png', 'webp', 'jfif'];

export const ALLOWED_ATTACHMENT_IMAGE_TYPES = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'tiff', 'bmp'];

export const MAX_FILE_SIZE_BYTES_99 = 99 * 1024 * 1024; // 99 MB
export const MAX_FILE_SIZE_BYTES_19 = 19 * 1024 * 1024; // 19 MB
export const MAX_FILE_SIZE_BYTES_100 = 100 * 1024 * 1024; // 100 MB
